<script setup lang="ts">
import { ref, computed, watch, getCurrentInstance } from 'vue';
import { isBoolean } from 'lodash';

const props = withDefaults(
  defineProps<{
    collapsible?: boolean;
    caption?: string | null;
    stateKey?: string | null;
  }>(),
  {
    collapsible: false,
    caption: null,
    stateKey: null,
  },
);

const instance = getCurrentInstance();
const proxy = instance?.proxy as any;
const $app = computed(() => proxy?.$root?.$app);

function getIsExpanded(): boolean {
  if (props.collapsible && props.stateKey) {
    const value = $app.value?.objectStore?.getItem(
      `panel.${props.stateKey}`,
      null,
    );
    if (value && isBoolean(value.isExpanded)) {
      return value.isExpanded;
    }
  }
  return true;
}

const isExpanded = ref(getIsExpanded());

watch(isExpanded, (value) => {
  if (props.collapsible && props.stateKey) {
    $app.value?.objectStore?.setItem(`panel.${props.stateKey}`, {
      isExpanded: value,
    });
  }
});

const className = computed(() => ({
  'itp-panel': true,
  'w-100': true,
  collapsible: props.collapsible,
  expanded: isExpanded.value,
}));

const iconName = computed(() =>
  isExpanded.value ? 'fa-angle-down' : 'fa-angle-right',
);

function onClick() {
  isExpanded.value = !isExpanded.value;
}
</script>

<template>
  <div :class="className">
    <ItpBox align-items="center" inline class="cursor-pointer" @click="onClick">
      <ItpIcon
        v-if="collapsible"
        class="ms-2 me-3 text-muted"
        :style="{ width: '1em' }"
        :name="iconName"
      />
      <strong>{{ caption }}</strong>
    </ItpBox>

    <div v-show="isExpanded">
      <slot></slot>
    </div>
  </div>
</template>
